/**
 * Maximum length of the client-reported UI language tag.
 *
 * The value is a BCP-47 tag ("cs", "cs-CZ", at most a script/region/variant chain), so 35 characters
 * is generous. The cap matters because the language reaches per-cell `Intl` formatter construction —
 * unbounded free text there is a cheap CPU amplifier.
 */
export const ASSISTANT_LANGUAGE_MAX_CHARACTERS = 35;
